import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../../components/AppBaseComponent';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from '../../../components/ui/TapSelect';
import moment from 'moment';
import DatePicker from "react-datepicker";
import TapIcon from '../../../services/TapIcon';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';
import TapInput from '../../../components/ui/TapInput';

class ChangeSite extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        this.initSiteTransitionForm     =       {
           site_id                      :         '',
           transaction_date             :         '',
           moving_employee_ids          :         [],
           moving_user_ids              :         [],
           new_roster_id                :         null,
           notes                        :         ""
        }

        
        this.state                  =   {
            name                        :   '',
            access_token                :   '',
            asset_id                    :   '',
            siteTransitionForm          :   {...this.initSiteTransitionForm},
            linked_roster               :   null,
            iam_user_sites              :   [] ,
            changeStatusFormSubmitting  :   false,
            allLinkedEmployeeList       :   [],
            allLinkedUsers              :   [],
            rosterOptions               :   [],
            isLoadingFormData           : false, 
            isLoadingAssetDetails       : false 
            
        }
        this.changeSiteModalId      =   uuid();
         this.assetDetailUrl                 =   IAM_API_BASE_URL_2 + '/asset_detail/__replace_asset_id';
    }

    
    componentDidMount               =   ()  =>  {
        this.initScreen(this.props);
        this.changeSiteModal            =   new Modal( document.getElementById(this.changeSiteModalId), {keyboard: false, backdrop :false}); 
        if (this.props.assetData?.asset_id) {
             this.setState({ isLoadingAssetDetails: true });
            let params = { need_keys: ['serial_numbers', 'users', 'site', 'workstation'] };
            HttpAPICall.withAthorization('GET', this.assetDetailUrl.replace('__replace_asset_id', this.props.assetData?.asset_id), this.props.access_token, params, {}, (response) => {
                const respData = response.data.data;
                
                this.setState({
                    // allLinkedEmployeeList: respData && respData.employees && respData.employees.length > 0 ? respData.employees.map(emp => { return ({ value: emp.enc_id, label: emp.name }) }) : [],
                    // allLinkedUsers: respData && respData.users && respData.users.length > 0 ? respData.users.map(emp => { return ({ value: emp.enc_id, label: emp.full_name }) }) : [],
                    iotIntegrationForm: { imei_number: respData?.imei_number, linked_iot_provider: respData?.linked_iot_vendor?.id },
                     isLoadingAssetDetails: false 
                });
            });
        }
    }
    
    componentWillReceiveProps(nextProps) {
            this.initScreen(nextProps);
    }
    
    initScreen                     =   (props)  =>  {
        this.setState({
            iam_user_sites      :       props.iam_user_sites && props.iam_user_sites.length > 0 ? props.iam_user_sites.map(s => {return({value : s.id , label : `${s.site_name} (${s.site_code})`})}) : []
        }, () => {
        })
        this.setState({access_token : props.access_token});
        this.setState({name : props.name});  
        
    
    }

    changeSiteModalInit               =   (asset_id)  =>  {
        this.getFormData(asset_id)
        this.changeSiteModal.show()
        let form = document.getElementById(`${this.changeSiteModalId}Form`)
        form.reset();
   }

    getFormData = (asset_id) => {
        this.setState({ isLoadingFormData: true });

        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + `/asset/site/form_data/${asset_id}`,
            this.props.access_token,
            null,
            {},
            (response) => {
                const data = response.data;
                const rosterOptions = data.rosters.map(roster => ({
                    value: roster.id,
                    label: `${roster.roster_name} (${roster.tap_roster_id})`
                }));
                let employees   =   data && data.employees && data.employees.length > 0 ? data.employees : [];
                let users       =   data && data.users && data.users.length > 0 ? data.users : [];


                this.setState({
                    asset_id: asset_id,
                    rosterOptions: rosterOptions,
                    allLinkedUsers: users.map(u => { return ({ value: u.enc_id, label: u.full_name }) }),
                    allLinkedEmployeeList: employees.map(e => { return ({ value: e.enc_id, label: e.name }) }),
                    siteTransitionForm: {
                        ...this.initSiteTransitionForm,
                        moving_user_ids: users.map(emp => emp.enc_id),
                        moving_employee_ids: employees.map(emp => emp.enc_id),
                        new_roster_id: null 
                    },
                    linked_roster : rosterOptions.find(r => r.value == data.linked_roster),
                    isLoadingFormData: false
                });
            }
        )

        this.setState({ currentSiteId: this.props.assetData?.site_id || '' });
    }

    submitSettingsForm = (e) => {
    
        e.preventDefault();
         let frmData = {
        ...this.state.siteTransitionForm,
        asset_id: this.state.asset_id,
        new_roster_id: this.state.siteTransitionForm.new_roster_id 
    };
        this.setState({ saveFormSubmitting: true })
        HttpAPICall.withAthorization('PUT', IAM_API_BASE_URL_2 + '/asset/site/change', this.props.access_token, null, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.props.afterChangeStatus()
            if (this.props?.listingRefresh) {
                this.props.listingRefresh()
            }
            this.changeSiteModal.hide();
            this.setState({ siteTransitionForm: { ...this.initSiteTransitionForm } })
        }).then(() => this.setState({saveFormSubmitting: false}))
            

    }
    changeSiteModalJsx                  =   ()  =>  {
       
        return (
            <div className="modal fade" id={this.changeSiteModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Change Site</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.state.isLoadingFormData || this.state.isLoadingAssetDetails ? <Loader /> :
                                <form className={['p-2',].join(' ')} onSubmit={this.submitSettingsForm} id={`${this.changeSiteModalId}Form`}>
                                    <div className="row align-items-center my-2">
                                        <label className="col-sm-3 col-form-label">Current Site</label>
                                        <div className="col-sm-7">
                                            <TapSelect
                                                options={this.state.iam_user_sites}
                                                value={this.state.iam_user_sites.find(u => this.state.currentSiteId == u.value)}
                                                isClearable={true}
                                                placeholder="Select Site"
                                                autoCompelete="off"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                isDisabled={true}
                                            />
                                        </div>
                                        <div className="col-sm-2">

                                        </div>
                                    </div>
                                    <div className="row align-items-center my-2">
                                        <label className="col-sm-3 col-form-label require">Shifted to</label>
                                        <div className="col-sm-7">
                                            <TapSelect
                                                options={this.state.iam_user_sites}
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'siteTransitionForm', 'site_id')}
                                                value={this.state.iam_user_sites.find(u => this.state.siteTransitionForm.site_id == u.value)}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Select Shifted to Site"
                                                autoCompelete="off"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                required={true}
                                            />
                                        </div>
                                        <div className="col-sm-2">

                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        <label className="col-sm-3 col-form-label require">Date of Transition</label>
                                        <div className="col-sm-7 add_calender_section">
                                            <DatePicker
                                                selected={
                                                    this.state.siteTransitionForm.transaction_date
                                                        ? moment(this.state.siteTransitionForm.transaction_date, 'YYYY-MM-DD HH:mm:ss').toDate()
                                                        : false
                                                }
                                                name="transaction_date"
                                                onChange={(value, event) => this.formDateHandler('transaction_date', value, 'siteTransitionForm', 'YYYY-MM-DD HH:mm:ss')}
                                                dateFormat="dd-MMM-yyyy hh:mm a"
                                                className={"form-control form-control-sm"}
                                                showMonthDropdown
                                                showYearDropdown
                                                showTimeSelect
                                                timeIntervals={5}
                                                timeCaption="Time"
                                                autoComplete="off"
                                                scrollMonthYearDropdown
                                                placeholderText={`Please Enter Transaction Date`}
                                                required={true}
                                                maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                            />
                                            <TapIcon.imageIcon icon={TapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                                            <div className='form-text'>Transition date can be any date after the latest CounterLog {this.props.assetData && this.props.assetData.latest_counterlog && this.props.assetData.latest_counterlog.feed_date_time_display ? <span>({this.props.assetData.latest_counterlog.feed_date_time_display})</span> : "-"} and after the previous transition date</div>
                                        </div>
                                        <div className="col-sm-2">

                                        </div>
                                    </div>
                                    {this.props.permissions.group_modules.includes("hrm") &&
                                        <div className="row align-items-center my-2">
                                            <label className="col-sm-3 col-form-label">Employee</label>
                                            <div className="col-sm-7">
                                                <TapSelect
                                                    options={this.state.allLinkedEmployeeList}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'siteTransitionForm', 'moving_employee_ids')}
                                                    value={this.state.allLinkedEmployeeList.filter(u => this.state?.siteTransitionForm?.moving_employee_ids?.includes(u.value))}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    placeholder="Select Employee"
                                                    autoCompelete="off"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                            <div className="col-sm-2">

                                            </div>
                                        </div>}
                                    <div className="row align-items-center my-2">
                                        <label className="col-sm-3 col-form-label">Users</label>
                                        <div className="col-sm-7">
                                            <TapSelect
                                                options={this.state.allLinkedUsers}
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'siteTransitionForm', 'moving_user_ids')}
                                                value={this.state.allLinkedUsers.filter(u => this.state?.siteTransitionForm?.moving_user_ids?.includes(u.value))}
                                                isClearable={true}
                                                isMulti={true}
                                                isSearchable={true}
                                                placeholder="Select Users"
                                                autoCompelete="off"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <div className="col-sm-2"></div>
                                    </div>
                                    <div className="row align-items-center my-2">
                                        <label className="col-sm-3 col-form-label">Linked roster</label>
                                        <div className="col-sm-7">
                                            <TapInput className='form-control form-control-sm' disabled value={this.state.linked_roster && this.state.linked_roster.label} />
                                        </div>
                                    </div>
                                    <div className="row align-items-center my-2">
                                        <label className="col-sm-3 col-form-label">Shift Roster For New Site</label>
                                        <div className="col-sm-7">
                                            {this.state.rosterOptions.length > 0 && (

                                                <TapSelect
                                                    options={this.state.rosterOptions}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'siteTransitionForm', 'new_roster_id')}
                                                    value={this.state.rosterOptions.find(option =>
                                                        option.value === this.state.siteTransitionForm.new_roster_id || null
                                                    )}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    placeholder="Select Roster"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="row align-items-center my-2">
                                        <label className="col-sm-3 col-form-label">Remarks</label>
                                        <div className="col-sm-7">
                                            <textarea
                                                name="notes"
                                                value={this.state.siteTransitionForm.notes}
                                                style={{ height: "80px" }}
                                                className="form-control"
                                                autoComplete="off"
                                                maxLength={500}
                                                onChange={(e) => this.formInputHandler(e, "siteTransitionForm")}
                                                placeholder="Please enter Remarks"
                                            />
                                        </div>
                                    </div>

                                    <div className="row align-items-center">
                                        <div className='form-text offset-3 col-sm-7'>
                                            <sup>*</sup>All Linked Sub Assembly will be transferred to this new Site
                                        </div>
                                    </div>
                                </form>
                            }
                        </div>
                        <div className="modal-footer row">
                              <div className="col text-end">
                            <button type="button" className="btn btn-secondary mx-2" disabled={this.state.saveFormSubmitting} data-bs-dismiss="modal">Close</button>
                            <button type="submit" className="btn btn-primary" disabled={this.state.saveFormSubmitting} form={`${this.changeSiteModalId}Form`}>Save {this.state.saveFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
    
    render (){
        return (<Ax>
            {this.changeSiteModalJsx()}
        </Ax>);
    }
    
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
         permissions             :       state.app && state.app.acl_info ? state.app.acl_info : null,
    };
};


export default connect(mapStateToProps, null, null, { forwardRef: true })(ChangeSite);